import Text from 'components/Text/Text';
import { ArchivedLabel } from 'components/Select/ArchivedLabel';
import React, { useContext, useEffect, useRef } from 'react';
import { Select } from 'antd';
import { IGetRestaurantsShort, IGetRestaurantsShortArgs, EntityStatus } from 'types';
import { useFetchData } from 'hooks/useFetchData';
import {
	DeviceFullInfoContext,
	IDeviceFullInfoContext,
} from '../../../../../deviceFullInfoState/deviceFullInfoContext';
import { getRestaurantsShortInfo } from 'backend/restaurants';
import style from './RestaurantField.module.scss';

const { Option } = Select;

const RestaurantField: React.FC = () => {
	const { deviceForFullInfo } = useContext<IDeviceFullInfoContext>(DeviceFullInfoContext);
	const parentNodeRef = useRef<null | HTMLSpanElement>(null);
	const { response, loading, refetch } = useFetchData<IGetRestaurantsShort, IGetRestaurantsShortArgs>(
		deviceForFullInfo?.customerId ? getRestaurantsShortInfo : null,
		{
			customerId: deviceForFullInfo?.customerId || '',
		},
	);

	useEffect(() => {
		refetch();
	}, [deviceForFullInfo]);

	return (
		<div className={style.container} data-test="restaurantLabel">
			<Text translationNameSpace="form" translationKey="restaurantLabel" theme="neutralLight" size="xs" />
			<span ref={parentNodeRef} style={{ position: 'relative' }} />
			<Select
				className={style.select}
				value={deviceForFullInfo?.restaurantId || '-'}
				loading={loading}
				bordered={false}
				showArrow={false}
				disabled={true}
				listItemHeight={response?.data.restaurants.length}
				getPopupContainer={() => parentNodeRef.current as HTMLSpanElement}>
				{response?.data.restaurants.length ? (
					<>
						{response.data.restaurants.map((el) => {
							return (
								<Option className={style.listItem} value={el.id} key={el.id}>
									{el.name}
									{el.status === EntityStatus.Archived && <ArchivedLabel />}
								</Option>
							);
						})}
					</>
				) : null}
			</Select>
		</div>
	);
};

export default RestaurantField;
